window.onload = function () {

  /* show / hide main nav
  -------------------------------------------------- */

  const btnnav = document.querySelector('.js-togglemenu');
  const mobilenav = document.querySelector('.js-navwrapper');
  const langnav = document.querySelector('.js-language');
  const dropdown = document.querySelector('.js-dropdown');

  // Toggle menu to visible
  btnnav.addEventListener("click", () => {
    mobilenav.classList.toggle('active');
  });

  // Toggle burger animation
  btnnav.onclick = function () {
    btnnav.classList.toggle('active'); // nav animation
  }

  langnav.addEventListener("click", () => {
    dropdown.classList.toggle('active');
  });

  // Noclick menuitem


  var submenu = document.querySelectorAll("a.no-click");

  submenu.forEach(function (show) {
    show.addEventListener("click", (event) => {
      event.preventDefault();
    });
  });

};


